import React, { Component } from 'react'

export default class ToolsHome extends Component {
    render() {
        return (
<div>
mostly for testing matrix-mab, haphazard and other js libraries
</div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/site/pages/tools/Home.js